import { Box, Typography } from "@mui/material";
import { getScaleConfig } from './ChartScales';

interface ChartInfoDisplayProps {
    chartDataLength: number;
    selectedMetricsLength: number;
    scaleGroups: Map<string, string[]>;
    storageName?: string;
    mode?: 'dark' | 'light';
}

export function ChartInfoDisplay({ chartDataLength, selectedMetricsLength, scaleGroups, storageName, mode = 'dark' }: ChartInfoDisplayProps) {
    return (
        <>
            <Typography variant="body2" sx={{ mb: 1, flexShrink: 0 }}>
                Showing {chartDataLength} data points for {selectedMetricsLength} metrics
            </Typography>

            {/* Display scale groups info with unit colors */}
            <Box sx={{
                mb: 1,
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                alignItems: 'center',
                flexShrink: 0
            }}>
                {/* Fix: Add explicit typing to the iterator elements */}
                {Array.from(scaleGroups.entries()).map((entry: [string, string[]]) => {
                    const [unit, metrics] = entry;
                    const scaleConfig = getScaleConfig(unit, mode);
                    return (
                        <Typography
                            key={unit}
                            variant="caption"
                            sx={{
                                px: 1,
                                py: 0.5,
                                backgroundColor: scaleConfig.color + '20', // 20% opacity
                                borderRadius: 1,
                                color: scaleConfig.color,
                                border: `1px solid ${scaleConfig.color}`,
                                fontWeight: 'bold'
                            }}
                        >
                            {unit}: {metrics.length} metrics
                        </Typography>
                    );
                })}
                {storageName && (
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main', ml: 1 }}>
                        {storageName}
                    </Typography>
                )}
            </Box>
        </>
    );
}